import type { ChangeEvent } from 'react'

import type { TitleProps } from '@/legacy/models'

import type { Space } from '../Container'
import type { MediaProps } from '../Media'

export type Item = {
  name: string
  midia: PartnerMidia
  link?: string
  width: number
  height: number
}

export interface PartnersListProps {
  items: Item[]
  spaceIn?: Space
  settingsLink: { link: string; label: string }
  title: TitleProps
  subtitle?: TitleProps
  cardButtonLabel: string
  concatenation: string
}
export type OptionChangeEvent = ChangeEvent<HTMLInputElement> &
  KeyboardEvent &
  React.MouseEvent<HTMLInputElement>

type PartnerMidia = Omit<MediaProps, 'midia'> & {
  image: MediaProps['image']
}

export type OrderKeys = keyof typeof order
export type OrderValues = ValueOf<typeof order>

export const order = {
  relevance: 'Relevância',
  alphabeticalAZ: 'Parceiros de A a Z',
  alphabeticalZA: 'Parceiros de Z a A',
} as const

export type Keyboard = ChangeEvent<HTMLInputElement> &
  React.KeyboardEvent &
  React.MouseEvent<HTMLInputElement>
